@if (progress !== null || phaseLabel !== 'Cargando...' || message) {
  <div class="loading-overlay" aria-live="polite" role="status">
    <div class="loading-overlay-content" (click)="$event.stopPropagation()">
      <mat-spinner color="primary" diameter="48"></mat-spinner>
      <strong>{{ phaseLabel }}</strong>
      @if (progress !== null) {
        <div class="loading-progress-track" role="progressbar" aria-label="Progreso de carga"
          [attr.aria-valuenow]="progressValue" aria-valuemin="0" aria-valuemax="100">
          <span class="loading-progress-fill" [style.width.%]="progressValue"></span>
        </div>
        <span class="loading-progress-value">{{ progressValue }}%</span>
      }
      @if (message) {
        <span class="loading-message">{{ message }}</span>
      }
      @if (showRetry) {
        <button mat-stroked-button type="button" (click)="requestRetry()">Reintentar</button>
      }
    </div>
  </div>
} @else {
  <div class="loading-overlay" aria-live="polite" role="status">
    <div class="loading-overlay-content" (click)="$event.stopPropagation()">
      <mat-spinner color="primary" diameter="48"></mat-spinner>
      <span>Cargando...</span>
    </div>
  </div>
}
